import "./App.css";
import Layout from "./container/layout/layout";
// import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

function App() {
  return (
    // <Router>
    //   <div className="App">
    //     <Layout />
    //     <Switch>
    //       <Route path='/' exact component={Home} />
    //       <Route path='/data' component={Data} />
    //       <Route path='/graph' component={Graph} />
    //       <Route path='/control' component={Control} />
    //     </Switch>
    //   </div>
    // </Router>
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
